import React, {Component} from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'

import ItemIcon from '@material-ui/icons/BeachAccess'

import PaperBlock from "../../../ui/PaperBlock"

import withStyles from '@material-ui/core/styles/withStyles'

const styles = theme => ({

})

/**
 * <ItemsList items selected onClickItem = {item} onDoubleClickItem = {item}/>
 */

class ItemsList extends Component {

	render() {
		return <PaperBlock>
			<List>
				{this.props.items.map(
					(item, n) => <ListItem
						key = {n}
						button
						selected = {this.props.selected ? this.props.selected.id === item.id : false}
						onClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onClickItem === "function") {
								this.props.onClickItem(item)
							}
						}}
						onDoubleClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onDoubleClickItem === "function") {
								this.props.onDoubleClickItem(item)
							}
						}}
					>
						<ListItemIcon>
							<ItemIcon />
						</ListItemIcon>
						<ListItemText primary = {item.name}/>
						<ListItemSecondaryAction>
							{item.amount}
						</ListItemSecondaryAction>
					</ListItem>
				)}
			</List>
		</PaperBlock>
	}

}

export default withStyles(styles)(ItemsList)
